import {
  EInvoiceStatus,
  EPaymentStatus,
  EFeeType,
}                        from '@enums/invoiceManagement';
import { ISelectOption } from '@typings/components';
import { IPricing } from '@typings/invoiceManagement';

export const INVOICE_STATUS_NAME: Record<EInvoiceStatus, string> = {
  [EInvoiceStatus.Unpaid] : 'Unpaid',
  [EInvoiceStatus.Paid]   : 'Paid',
};

export const PAYMENT_STATUS_NAME: Record<EPaymentStatus, string> = {
  [EPaymentStatus.Unpaid] : 'Unpaid',
  [EPaymentStatus.Paid]   : 'Paid',
  [EPaymentStatus.Waived] : 'Waived',
};

export const invoiceStatusOptions: ISelectOption[] = [
  { label: INVOICE_STATUS_NAME[EInvoiceStatus.Unpaid], value: EInvoiceStatus.Unpaid },
  { label: INVOICE_STATUS_NAME[EInvoiceStatus.Paid],   value: EInvoiceStatus.Paid },
];

export const paymentStatusOptions: ISelectOption[] = [
  { label: PAYMENT_STATUS_NAME[EPaymentStatus.Unpaid], value: EPaymentStatus.Unpaid },
  { label: PAYMENT_STATUS_NAME[EPaymentStatus.Paid],   value: EPaymentStatus.Paid },
  { label: PAYMENT_STATUS_NAME[EPaymentStatus.Waived], value: EPaymentStatus.Waived },
];

export const PRICING_LABELS: Record<keyof IPricing, string> = {
  monthlyFee            : 'Monthly Fee',
  dealerFee             : 'Dealer Administration Fee',
  personalFee           : 'Personal Administration Fee',
  nadaBookOutFee        : 'J.D. Power Book-Out Fees',
  nadaMonthlyFee        : 'J.D. Power Monthly Fee',
  expressRecoveryFee    : 'Express Recoveries Monthly Fee',
  deficiencyTrackingFee : 'Deficiency Tracking Monthly Fee',
  vrmFee                : 'VRM Monthly Fee',
  srsFee                : 'SRS Monthly Fee',
  reindeerFee           : 'Reindeer Fee',
};

export const PRICING_LABELS_WITHOUT_JPPOWER: Record<keyof Omit<IPricing, 'nadaMonthlyFee' | 'nadaBookOutFee'>, string> = {
  monthlyFee            : 'Monthly Fee',
  dealerFee             : 'Dealer Administration Fee',
  personalFee           : 'Personal Administration Fee',
  expressRecoveryFee    : 'Express Recoveries Monthly Fee',
  deficiencyTrackingFee : 'Deficiency Tracking Monthly Fee',
  vrmFee                : 'VRM Monthly Fee',
  srsFee                : 'SRS Monthly Fee',
  reindeerFee           : 'Reindeer Fee',
};

export const FEE_PRICING_KEYS: Partial<Record<EFeeType, keyof IPricing>> = {
  [EFeeType.Monthly]                   : 'monthlyFee',
  [EFeeType.NadaMonthlyFee]            : 'nadaMonthlyFee',
  [EFeeType.NadaBookOutFee]            : 'nadaBookOutFee',
  [EFeeType.ExpressRecoveryMonthlyFee] : 'expressRecoveryFee',
  [EFeeType.DeficiencyTrackingFee]     : 'deficiencyTrackingFee',
  [EFeeType.VrmFee]                    : 'vrmFee',
  [EFeeType.SrsFee]                    : 'srsFee',
  [EFeeType.ReindeerFee]               : 'reindeerFee',
};
